import { Box, Button, Card, CardActions, CardContent, CardHeader, Chip, IconButton, Typography } from "@mui/material";
import { Movimentacao } from "../../mov.model";
import { EditDocument, Handshake, Search } from "@mui/icons-material";

interface CardClienteProps {
    mov: Movimentacao;
    clienteActions: any;
    mutatorLocal: (value: any, field: string) => void;
}
export const CardCliente = (props: CardClienteProps) => {
    const { mov, clienteActions, mutatorLocal } = props;
    if (mov.pessoa._id === undefined)
        return <Card sx={{ display: "flex", flex: 1, flexDirection: "column" }}></Card>;

    return (
        <Card sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
            <CardHeader
                disableTypography
                title={"Cliente"}
                action={
                    <IconButton
                        title="Selecionar Cliente"
                        size="small"
                        onClick={() => clienteActions.setShowSelectModal(true)}
                    >
                        <Search />
                    </IconButton>
                }
            />
            <CardContent sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                <Box sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
                    <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                        <Typography>{mov.pessoa.nome}</Typography>
                        <Typography>{mov.pessoa.whatsapp}</Typography>
                    </Box>
                    {mov.pessoa.revenda && (
                        <Chip label="Revendedor" icon={<Handshake fontSize="large" />} color="success" />
                    )}
                </Box>

                <CardActions sx={{ display: "flex", flex: 1, justifyContent: "center" }} >
                    {mov.pessoa._id && (
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => {
                                clienteActions.get(mov.pessoa._id);
                                clienteActions.setShowCadModal(true);

                            }}
                            startIcon={<EditDocument />}
                        >
                            Editar Cadastro
                        </Button>
                    )}
                </CardActions>


            </CardContent>
        </Card>
    )
}